import { Node_Type } from 'ricos-schema';
import ParagraphRenderer from './paragraph/paragraph.js';
import BlockquoteRenderer from './blockquote/blockquote.js';
import CodeBlockRenderer from './codeblock/codeblock.js';
import HeadingRenderer from './heading/heading.js';
import BulletedListRenderer from './lists/bulletedList.js';
import OrderedListRenderer from './lists/orderedList.js';
import ListItemRenderer from './lists/listItem.js';
import TextRenderer from './text/text.js';
import 'react';
import 'ricos-context';
import '../../../alignment.rtlignore-bc42ede7.js';
import '../../../rtl.rtlignore-1b0960bd.js';
import '../../../indentation-b1f5c3c0.js';
import './consts.js';
import 'classnames';
import '../utils/Anchorable.js';
import '../utils/paywallSeo.js';
import 'wix-rich-content-common';
import 'ricos-converters';
import '../../../lists-05124ec3.js';

const renderers = {
  [Node_Type.PARAGRAPH]: ParagraphRenderer,
  [Node_Type.TEXT]: TextRenderer,
  [Node_Type.BLOCKQUOTE]: BlockquoteRenderer,
  [Node_Type.CODE_BLOCK]: CodeBlockRenderer,
  [Node_Type.HEADING]: HeadingRenderer,
  [Node_Type.BULLETED_LIST]: BulletedListRenderer,
  [Node_Type.ORDERED_LIST]: OrderedListRenderer,
  [Node_Type.LIST_ITEM]: ListItemRenderer
};

export { renderers as default };
//# sourceMappingURL=index.js.map
